<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>{{$t('pages.dashboard.title')}}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <GChart
          :settings="{ packages: ['corechart', 'table', 'map'] }"
          type="ColumnChart"
          :data="chartData"
          :options="chartOptions"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import jwt from "@/store/jwt";

export default {
  name: "Dashboard",
  data() {
    return {
      roles: jwt.getJwtRoles(),
      chartData: [],
      chartOptions: {
        title: "Počet optimalizácií",
        // chart: {
        //   title: "Optimalizácia",
        //   subtitle: "Sales, Expenses, and Profit: 2014-2017"
        // },
        colors: ["#81a3a7"]
      }
    };
  },
  created() {
    this.getOptimizationData();
  },
  methods: {
    getOptimizationData() {
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .customerService()
        .getCustomerOptimization()
        .then(response => {
          this.chartData = [];
          this.chartData.push(["Meno", "Počet"]);
          response.data.forEach(element => {
            return this.chartData.push([element.name, element.count]);
          });
          console.log(this.chartData);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    }
  }
};
</script>
